<app-additional-services
  [offers]="offers$ | async"
  [selected]="selected$ | async"
  [offerReference]="offerReference$ | async"
>
</app-additional-services>
